// extracted by mini-css-extract-plugin
module.exports = {"space40":"space40-2GEqg6Fv","space10":"space10-1DZpwn0B"};